
export const root = {
  width: '20px',
  height: '20px',
  background: 'transparent',
  checkedBackground: 'transparent',
  checkedHoverBackground: 'transparent',
  disabledBackground: 'var(--white-60)',
  filledBackground: 'transparent',
  borderColor: 'var(--primary-blue-20)',
  hoverBorderColor: 'var(--primary-blue-100)',
  focusBorderColor: 'var(--primary-blue-100)',
  checkedBorderColor: 'var(--primary-blue-100)',
  checkedHoverBorderColor: 'var(--primary-blue-100)',
  checkedFocusBorderColor: 'var(--primary-blue-100)',
  checkedDisabledBorderColor: 'var(--primary-blue-100)',
  invalidBorderColor: 'var(--primary-red-100)',
  shadow: '{form.field.shadow}',
  focusRing: {
    width: '3px',
    style: '{focus.ring.style}',
    color: 'var(--primary-active-40)',
    offset: '{focus.ring.offset}',
    shadow: '{focus.ring.shadow}'
  },
  transitionDuration: '{form.field.transition.duration}',
  sm: {
    width: '1rem',
    height: '1rem'
  },
  lg: {
    width: '1.5rem',
    height: '1.5rem'
  }
};

export const icon = {
  size: '0.75rem',
  checkedColor: 'var(--primary-blue-100)',
  checkedHoverColor: 'var(--primary-blue-100)',
  disabledColor: 'var(--primary-blue-100)',
  sm: {
    size: '12px'
  },
  lg: {
    size: '12px'
  }
};

export default {
  root,
  icon
}